module.exports = __webpack_public_path__ + "media/images/icons/settings-01fea085a9bfe3b6cb668181ba1a5674.svg";